// Shared callout for product surfaces that record state locally but do
// NOT yet drive controller-enforced access, so operators never mistake
// portal-only records for hardware policy.
//
// Consumers: Buildings, Units, Households, Residents, Amenities, Guest
// Passes, Callbox Directory. (This list previously named pages that did
// not use it and omitted the ones that did — keep it honest, it is the
// only place the set is written down.)

import { Icon } from '@ng-unifi/ui';

export function LocalOnlyBanner({ title, body }: { title: string; body: string }) {
  return (
    <div
      role="status"
      className="bg-tertiary-fixed text-on-tertiary-fixed border border-tertiary-fixed-dim rounded-lg px-4 py-3 font-body-md text-body-md flex items-start gap-2"
    >
      <Icon name="info" />
      <div>
        <strong className="font-label-md text-label-md uppercase">{title}</strong>
        <p>{body}</p>
      </div>
    </div>
  );
}
